// Can See password
const icon = $('.j-toggle-visibility');

icon.on('click', function () {
  const pass = $(this).parent().find('.c-input-pass');

  if (pass.attr('type') === 'password') {
    pass.attr('type', 'text');
    $(this).children('i').removeClass('fa-eye');
    $(this).children('i').addClass('fa-eye-slash');
  } else {
    pass.attr('type', 'password');
    $(this).children('i').removeClass('fa-eye-slash');
    $(this).children('i').addClass('fa-eye');
  }
});
